module.exports = __webpack_public_path__ + "media/headers/quienes_somos-640e586e.png";